import { useCallback, useContext } from "react";

import type { AgenticAiState } from "@lib/agenticAi";
import { AgenticAiAvailabilityContext, initialAgenticAiState } from "@lib/agenticAi";

import { useAgenticAiExternalStoreSelector } from "@services/useAgenticAiExternalStoreSelector";

export const useAgenticAiSelector = <Selected>(selector: (state: AgenticAiState) => Selected): Selected => {
  const isAgenticAiAvailable = useContext(AgenticAiAvailabilityContext);
  const selectAvailableState = useCallback(
    (state: AgenticAiState): Selected => selector(isAgenticAiAvailable ? state : initialAgenticAiState),
    [isAgenticAiAvailable, selector]
  );

  return useAgenticAiExternalStoreSelector(selectAvailableState, isAgenticAiAvailable);
};
